/**
 * BillingCancelPage.jsx
 * Exibida quando o usuário cancela o Stripe Checkout.
 * Não houve cobrança. Convida a voltar para os planos.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { useSportsLang } from '../../contexts/SportsLangContext';

const BRAND_GREEN = '#064e3b';

const BillingCancelPage = () => {
  const { lang } = useSportsLang();
  const T = {
    pt: {
      title: 'Checkout cancelado',
      desc: 'Nenhuma cobrança foi realizada. Você pode assinar quando estiver pronto.',
      viewPlans: 'Ver planos novamente →',
      dashboard: 'Continuar no painel',
    },
    en: {
      title: 'Checkout cancelled',
      desc: 'No charge was made. You can subscribe whenever you are ready.',
      viewPlans: 'View plans again →',
      dashboard: 'Continue to dashboard',
    },
  }[lang] || {};

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4"
      style={{ backgroundColor: '#f8fafc' }}
    >
      <div className="bg-white rounded-2xl border border-gray-200 shadow-xl max-w-md w-full p-10 text-center">
        <div
          className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 text-4xl"
          style={{ backgroundColor: '#fef9c3' }}
        >
          🔄
        </div>

        <h1 className="text-2xl font-extrabold mb-2 text-gray-800">
          {T.title}
        </h1>
        <p className="text-gray-500 text-sm mb-8">
          {T.desc}
        </p>

        <div className="flex flex-col gap-3">
          <Link
            to="/pricing"
            className="w-full py-3 rounded-xl font-bold text-white text-center block"
            style={{ backgroundColor: BRAND_GREEN }}
          >
            {T.viewPlans}
          </Link>
          <Link
            to="/governance"
            className="w-full py-3 rounded-xl font-bold text-center block border-2"
            style={{ borderColor: BRAND_GREEN, color: BRAND_GREEN }}
          >
            {T.dashboard}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BillingCancelPage;
